import React from "react";
import Form from "../forms/form";

import MyCountdown from "../parts/countdown";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import FormatsDecor from "../../img/decor/format_decor.png";
import FormatsDecor_2 from "../../img/decor/format_decor_2.png";
import GetLogo from "../../img/get_logo.svg";


const formats = [
    {
        id: "standard",
        title: "STANDARD",
        price: "1000",
        oldPrice: "2500",
        bg: "bg-[#EEEEFF]",
        textColor: "text-black",
        cardBg: "bg-white",
        cutoutColor: "#EEEEFF",
        image: FormatsDecor,
        features: [
            "Відвідування GET Business Festival офлайн",
            "Доступ до всіх сцен",
            "Можливість поставити запитання спікерам",
            "Нетворкінг з учасниками фестивалю",
            "Кава-брейки",
            "Виставкова зона",
            "Презентації спікерів GET",
            "Запис трансляції всіх сцен фестивалю",
            "Фотозвіт з фестивалю",
        ],
    },
    {
        id: "vip",
        title: "VIP VIP VIP",
        price: "3000",
        oldPrice: "5000",
        bg: "bg-[#00007C]",
        textColor: "text-white",
        cardBg: "bg-[#EEEEFF]",
        cutoutColor: "#00007C",
        image: FormatsDecor,
        features: [
            "Відвідування GET Business Festival офлайн",
            "Доступ до всіх сцен",
            "Можливість поставити запитання спікерам",
            "Нетворкінг з учасниками фестивалю",
            "Кава-брейки",
            "Виставкова зона",
            "Презентації спікерів GET",
            "Запис трансляції всіх сцен фестивалю",
            "Фотозвіт з фестивалю",
            "Окрема стійка реєстрації",
            "Нетворкінг зі спікерами",
            "Бізнес-бранч"
        ],
    },
];

const Formats = () => {
    return (
        <section id="formats" className="bg-[#EEEEFF] pt-[60px] lg:pt-[120px]">
            <div className="container max-w-full mx-auto px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]">
                <h2 className="text-[clamp(34px,calc(34px+53*((100vw-390px)/1530)),87px)] 
                            mb-[25px] xl:mb-[40px]
                 font-black text-[#26265d]  uppercase leading-[1.2]">
                    Формати участі
                </h2>

                <p className="text-[16px] text-[#292967] text-[18px] leading-[1.2]">
                    Оберіть зручний формат участі
                </p>
            </div>

            {formats.map((format) => (
                <div
                    key={format.id}
                    className={`${format.bg} ${format.textColor}`}
                >
                    <div
                        className="
                            max-w-full mx-auto px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]
                            py-[clamp(24px,4vw,60px)]
                            md:grid
                            md:grid-cols-[minmax(0,1.1fr)_minmax(280px,0.9fr)]
                            gap-[clamp(28px,5vw,80px)]
                        "
                    >
                        {/* Билет */}
                        <div
                            className={`
                                relative grid
                                grid-cols-[minmax(0,1fr)_92px]
                                md:grid-cols-[minmax(0,1fr)_180px]
                                xl:grid-cols-[minmax(0,1fr)_280px]
                                overflow-hidden
                                shadow-[0_0_10px_0_rgba(0,0,0,0.15)]
                                ${format.cardBg}
                            `}
                        >
                            {/* Левая часть билета */}
                            <div className="relative min-h-[140px] md:min-h-[270px]">
                                <img src={format.image} alt=""  className="w-full object-cover" />

                                {/* MOBILE: цена слева */}
                                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 flex gap-2 md:hidden">
                                    <div className="flex items-end gap-1">
                                        <span className="text-[22px] font-bold leading-none text-[#00007C]">
                                            {format.price}
                                        </span>

                                        <span className="text-[9px] font-bold text-[#00007C]">
                                            грн*
                                        </span>
                                    </div>

                                    <div className="flex items-end gap-1">
                                        <span className="text-[22px] font-bold leading-none text-[#A8A8CE] line-through">
                                            {format.oldPrice}
                                        </span>
                                        <span className="text-[9px] text-[#A8A8CE]">
                                            грн*
                                        </span>
                                    </div>
                                </div>

                                {/* DESKTOP: картинка занимает левую часть */}

                                <img src={GetLogo} alt="" className="w-[clamp(70px,calc(70px+175*((100vw-390px)/1530)),245px)]
                                 absolute top-1/2 left-[40px] -translate-y-1/2 object-contain hidden md:block"/>


                                {/* Название тарифа */}
                                <div
                                    className={`
                                        absolute
                                        bottom-0
                                        left-1/2
                                        -translate-x-1/2
                                        z-20
                                        text-[30px]
                                        font-bold
                                        uppercase
                                        text-nowrap
                                        leading-[0.82]
                                        md:text-[clamp(32px,4vw,70px)]
                                        ${
                                            format.id === "vip"
                                                ? "text-white [text-shadow:0_0_6px_rgba(0,0,0,0.1)]"
                                                : " text-transparent bg-clip-text bg-[linear-gradient(110deg,#C8F4F0_0%,#A8BFFF_18%,#D7A7F5_32%,#F1D9EA_42%,#BDEFF2_52%,#8EB8F4_66%,#8589F1_82%,#7774E8_100%)]"
                                        }
   
                                    `}
                                >
                                    {format.title}
                                </div>
                            </div>

                            {/* Правая часть билета */}
                            <div className="relative min-h-[140px] md:min-h-[270px] max-md:flex max-md:flex-col
                                max-md:justify-between max-md:items-center max-md:pt-[25px]">
                                {/* MOBILE: справа только картинка */}
                                    
                                <img src={GetLogo} alt="" className="w-[70px] object-contain md:hidden"/>
                                <img src={FormatsDecor_2} alt="" className="w-[67px] ml-2 object-contain md:hidden"/>


                                {/* DESKTOP: цена + кнопка */}
                                <div className="hidden h-full flex-col items-center justify-between 
                                    py-[25px] xl:py-[45px] px-[18px] md:flex lg:px-[24px]">
                                    <div>
                                        <div className="flex items-end gap-1 mb-1
                                            text-[clamp(28px,2.4vw,53px)] font-black leading-none text-[#00007C]">
                                            <span className="">
                                                {format.price}
                                            </span>
                                            <span className="text-[9px] lg:text-[14px] xl:text-[19px]">
                                                грн*
                                            </span>
                                        </div>

                                        <div className="flex items-center gap-1 text-[rgba(0,0,124,0.2)] leading-none font-black relative">
                                            <span className="text-[clamp(28px,2.4vw,53px)] ">
                                                {format.oldPrice}
                                            </span>

                                            <span className="text-[9px] lg:text-[14px] xl:text-[19px]">
                                                грн*
                                            </span>
                                            <span className="block absolute -left-[5px] top-1/2 -translate-y-1/2
                                                w-[100%] h-[2px] bg-[#e53226] opacity-80 -rotate-6"></span>
                                        </div>
                                    </div>

                                    <a
                                        href="#frstscrn"
                                        className="
                                            mt-[24px]
                                            flex min-h-[42px]
                                            w-full
                                            items-center
                                            justify-center
                                            bg-[#FFD87C]
                                            px-4
                                            text-center
                                            text-[14px]
                                            font-bold
                                            lg:text-[16px]
                                            xl:text-[20px]
                                            uppercase
                                            text-black
                                            transition-opacity
                                            duration-300
                                            hover:opacity-80
                                        "
                                    >
                                        Взяти участь
                                    </a>
                                </div>
                            </div>

                            {/* Вертикальная линия отрыва */}
                            <div
                                className="
                                    pointer-events-none
                                    absolute
                                    bottom-0
                                    right-[92px]
                                    top-0
                                    z-30
                                    md:right-[180px]
                                    xl:right-[280px]
                                "
                            >
                                {/* Пунктир */}
                                <div
                                    className="
                                        absolute
                                        bottom-[12px]
                                        left-0
                                        top-[12px]
                                        w-px
                                    "
                                    style={{
                                        backgroundImage:
                                            "repeating-linear-gradient(to bottom, #26265D 0 5px, transparent 5px 10px)",
                                    }}
                                />

                                {/* Верхний вырез */}
                                <span
                                    className="
                                        absolute
                                        -left-[11px]
                                        -top-[11px]
                                        size-[22px]
                                        rounded-full
                                        z-20
                                        xl:size-[40px]
                                        
                                        xl:-left-[18px]
                                        xl:-top-[18px]
                                    "
                                    style={{
                                        backgroundColor: format.cutoutColor,
                                    }}
                                />

                                {/* Нижний вырез */}
                                <span
                                    className="
                                        absolute
                                        -bottom-[11px]
                                        -left-[11px]
                                        size-[22px]
                                        rounded-full
                                        z-20
                                        xl:size-[40px]
                                        
                                        xl:-left-[18px]
                                        xl:-bottom-[18px]
                                    "
                                    style={{
                                        backgroundColor: format.cutoutColor,
                                    }}
                                />
                            </div>
                        </div>

                        {/* Список преимуществ */}
                        <div className="mt-[18px] md:mt-0">
                            <ul className="space-y-[6px] md:space-y-[8px]">
                                {format.features.map((feature, index) => (
                                    <li
                                        key={index}
                                        className={`
                                            relative
                                            pl-[26px]
                                            text-[16px]
                                            leading-[1.25]
                                            lg:text-[18px]
                                            before:absolute
                                            before:left-0
                                            before:top-[0.4em]
                                            before:size-[6px]
                                            before:rounded-full
                                            before:bg-current
                                            ${format.id === "vip" ? "text-white" : "text-[#26265d]"}
                                        `}
                                    >
                                        {feature}
                                    </li>
                                ))}
                            </ul>

                            {/* MOBILE: кнопка под списком */}
                            <a
                                href="#frstscrn"
                                className="
                                    mt-[18px]
                                    flex
                                    min-h-[42px]
                                    w-full
                                    items-center
                                    justify-center
                                    bg-[#FFD87C]
                                    px-5
                                    text-center
                                    text-[16px]
                                    font-bold
                                    uppercase
                                    text-black
                                    md:hidden
                                "
                            >
                                Взяти участь
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </section>
    );
};

export default Formats;